import * as React from 'react';
import { graphql } from 'react-apollo';

import gql from 'graphql-tag';
import { compose } from 'recompose';
import _ from 'underscore';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';
import user from 'js/lib/user';

import TopReviewCard from 'bundles/reviews-common/components/TopReviewCard';
import type { TopReview, TopReviewIdAndVoteType } from 'bundles/reviews-common/types/reviewsSharedTypes';

import 'css!bundles/reviews-common/components/__styles__/TopReviewCards';

type InputProps = {
  topReviews: Array<TopReview>;
};

type Props = {
  topReviews: Array<TopReview>;
  topReviewIdsAndVoteTypes: Array<TopReviewIdAndVoteType>;
  router: InjectedRouter;
};

const TopReviewCards: React.SFC<Props> = ({ topReviews, topReviewIdsAndVoteTypes, router }) => {
  if (!topReviews || topReviews.length < 2) {
    return null;
  }

  return (
    <section className="top-reviews-module">
      <div className="top-reviews-container horizontal-box">
        {topReviews.slice(0, 2).map((topReview) => {
          const { reviewId } = topReview;
          const reviewData =
            topReviewIdsAndVoteTypes && topReviewIdsAndVoteTypes.find((review) => review.id === reviewId);

          return (
            <TopReviewCard
              topReview={topReview}
              originalReviewData={reviewData}
              userId={user.get().id}
              router={router}
              key={`top-review-${reviewId}`}
            />
          );
        })}
      </div>
    </section>
  );
};

const VLPHelpfulReviewsQuery = gql`
  query VLPHelpfulReviewsQuery($productReviewIds: [String!]!) {
    ProductReviewsV1Resource {
      multiGet(ids: $productReviewIds) {
        elements {
          id
          isMarkedHelpful
        }
      }
    }
  }
`;

export default compose<Props, InputProps>(
  connectToRouter((router) => ({ router })),
  graphql(VLPHelpfulReviewsQuery, {
    // @ts-expect-error TSMIGRATION
    props: ({ data: { ProductReviewsV1Resource } = {} }) => {
      const topReviewIdsAndVoteTypes =
        ProductReviewsV1Resource && ProductReviewsV1Resource.multiGet && ProductReviewsV1Resource.multiGet.elements;

      return { topReviewIdsAndVoteTypes };
    },
    // @ts-expect-error TSMIGRATION
    options: ({ topReviews }) => {
      const reviewIds = _.pluck(topReviews, 'reviewId');

      return {
        variables: {
          productReviewIds: reviewIds,
        },
      };
    },
    skip: () => !user.get().id,
  })
)(TopReviewCards);
